import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Eyebrow, LuxButton } from "@/components/lux";

const DEF = {
  privacy: { key: "privacy_policy", title: "Privacy Policy", fallback: "LUHAI respects your privacy. Information you submit through booking, quote and contact forms is used solely to respond to your inquiry and deliver your photography session. We never sell or share your personal data with third parties." },
  terms: { key: "terms", title: "Terms & Conditions", fallback: "By booking with LUHAI you agree to our session terms. All bookings are requests until confirmed by LUHAI. A deposit secures your date and is non-refundable. RAW / unedited files are not included. Additional time, locations, outfits and images may be charged separately." },
  "booking-policy": { key: "booking_policy", title: "Booking Policy", fallback: "A deposit is required to secure your session date. Rescheduling is available with reasonable notice. No-shows or late cancellations may forfeit the deposit. Final edited images are delivered according to your selected package turnaround time." },
};

export default function PolicyPage({ which }) {
  const [settings, setSettings] = useState({});
  const navigate = useNavigate();
  const meta = DEF[which];
  useEffect(() => { window.scrollTo(0, 0); api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, [which]);
  const body = settings[meta.key] || meta.fallback;
  return (
    <div className="bg-[#090A0F] min-h-screen">
      <Header />
      <main className="pt-32 sm:pt-40 pb-24">
        <div className="mx-auto max-w-[820px] px-5 sm:px-8">
          <Eyebrow>Legal</Eyebrow>
          <h1 className="font-display font-bold text-white text-4xl sm:text-5xl mt-3" data-testid="policy-title">{meta.title}</h1>
          <div className="text-[#94A3B8] leading-relaxed mt-8 whitespace-pre-wrap" data-testid="policy-body">{body}</div>
          <LuxButton className="mt-10" variant="outline" onClick={() => navigate("/")}>RETURN HOME</LuxButton>
        </div>
      </main>
      <Footer settings={settings} />
    </div>
  );
}
